module.exports = __webpack_public_path__ + "static/media/qr-code.633b5619.png";